import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e02b0cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "input-icon-left",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "sr-only" }
const _hoisted_3 = ["id", "value", "placeholder", "aria-expanded"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sr-only",
  id: "assistiveHint"
}, "When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.", -1))
const _hoisted_5 = {
  key: 0,
  class: "suggestions"
}
const _hoisted_6 = {
  id: "suggestions",
  role: "listbox",
  "arial-label": "search suggestions",
  "aria-live": "polite"
}
const _hoisted_7 = ["id", "aria-selected", "aria-setsize"]
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 1,
  href: "/search"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Browse all events", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["id", "aria-selected", "aria-posinset", "aria-setsize"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["search", _ctx.theme])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_font_awesome_icon, { icon: "search" })
    ]),
    _createElementVNode("form", {
      action: ".",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("label", null, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1),
        _createElementVNode("input", {
          id: `${_ctx.componentGuid}--search`,
          type: "search",
          name: "search",
          value: _ctx.modelValue,
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
          placeholder: _ctx.label,
          role: "combobox",
          "aria-autocomplete": "list",
          "aria-controls": "#suggestions",
          "aria-describedby": "searchHint assistiveHint",
          "aria-expanded": _ctx.expanded,
          onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleInputKeyup && _ctx.handleInputKeyup(...args))),
          onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleInputKeydown && _ctx.handleInputKeydown(...args)))
        }, null, 40, _hoisted_3),
        _hoisted_4
      ])
    ], 32),
    (_ctx.expanded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            (_ctx.showSearchFor)
              ? (_openBlock(), _createElementBlock("li", {
                  class: "show-all-results",
                  id: `${_ctx.componentGuid}--suggestions--${0}`,
                  role: "option",
                  key: `show-all-results--${_ctx.modelValue}`,
                  tabindex: "-1",
                  "aria-selected": _ctx.currentSuggestion === 0,
                  "aria-posinset": 1,
                  "aria-setsize": _ctx.suggestionListLength,
                  onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSuggestionListKeyup && _ctx.handleSuggestionListKeyup(...args))),
                  onKeydown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleSuggestionListKeydown && _ctx.handleSuggestionListKeydown(...args)))
                }, [
                  (_ctx.modelValue)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: `/search?q=${_ctx.modelValue}`
                      }, [
                        _createElementVNode("div", null, "Search for \"" + _toDisplayString(_ctx.modelValue) + "\"", 1)
                      ], 8, _hoisted_8))
                    : (_openBlock(), _createElementBlock("a", _hoisted_9, _hoisted_11))
                ], 40, _hoisted_7))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hits, (hit, index) => {
              return (_openBlock(), _createElementBlock("li", {
                id: `${_ctx.componentGuid}--suggestions--${
            index + (_ctx.showSearchFor ? 1 : 0)
          }`,
                role: "option",
                key: index,
                tabindex: "-1",
                "aria-selected": _ctx.currentSuggestion === index + (_ctx.showSearchFor ? 1 : 0),
                "aria-posinset": index + 1 + (_ctx.showSearchFor ? 1 : 0),
                "aria-setsize": _ctx.suggestionListLength,
                onKeyup: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleSuggestionListKeyup && _ctx.handleSuggestionListKeyup(...args))),
                onKeydown: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleSuggestionListKeydown && _ctx.handleSuggestionListKeydown(...args)))
              }, [
                _renderSlot(_ctx.$slots, "default", {
                  hit: hit,
                  index: index
                }, undefined, true)
              ], 40, _hoisted_12))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2)), [
    [_directive_click_outside, _ctx.handleClickOutside]
  ])
}